export { isNaN, rgba, getRGB, uiFocus, uiFocusObject, canReadText } from './color';